// extracted by mini-css-extract-plugin
module.exports = {"mobile-footer-wrapper":"mobile-footer-wrapper","menu-list":"menu-list","icon":"icon","bm-btn":"bm-btn","is-active":"is-active"};